var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.value === 'Tout sélectionner')?_c('div',[_vm._v(" Tout sélectionner ")]):_c('div',{class:{
      'text-green-700': this.value,
      'text-yellow-700': !this.value
    }},[_vm._v(" "+_vm._s(_vm.params.tag.labels[this.value ? 'true' : 'false'])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }